import router from "@/router/index";
import store from "@/store";

router.beforeEach((to, from, next) => {
  const whiteList = ["/", "/webpage", "/login", "/user/captchaPillow"]; // 白名单
  let token = window.sessionStorage.getItem("token");
  let menuList = JSON.parse(window.sessionStorage.getItem("menuList"));
  let hasRoutes = store.state.hasRoutes;

  // 如果路径包含 "webpage"，直接放行
  if (to.path.includes("/webpage")) {
    return next(); // 直接返回，不再执行后续逻辑
  }

  // 独立子站点由 Nginx 挂载 /iot/、/video/；若误返回本 SPA 的 index.html，勿重定向到本站 /login
  if (
    to.path === "/iot" ||
    to.path.startsWith("/iot/") ||
    to.path === "/video" ||
    to.path.startsWith("/video/")
  ) {
    return next();
  }

  // 如果用户已经拥有 token 并且尝试访问登录页面，则重定向到首页
  if (token && to.path === "/login") {
    return next({ path: "/admin/index" });
  }

  // 如果没有 token，跳转到登录页面
  if (!token) {
    if (whiteList.includes(to.path)) {
      return next(); // 白名单中路径放行
    }
    return next("/login"); // 跳转到登录页面
  }

  // 用户已登录状态
  if (token) {
    if (!hasRoutes) {
      bindRoute(menuList);
      store.commit("SET_ROUTES_STATE", true);
    }
    return next(); // 已登录用户放行
  }

  // 判断是否找到匹配的路由
  const resolved = router.resolve(to.path);
  if (resolved.matched.length === 0) {
    return next("/admin"); // 如果没有匹配的路由，重定向到默认页面
  }
});

// 动态绑定路由
const bindRoute = (menuList) => {
  let newRoutes = router.options.routes;
  menuList.forEach((menu) => {
    if (menu.children) {
      menu.children.forEach((m) => {
        let route = menuToRoute(m, menu.name);
        if (route) {
          newRoutes[0].children.push(route);
        }
      });
    }
  });

  // 重新添加到路由
  newRoutes.forEach((route) => {
    router.addRoute(route);
  });
};

// 菜单对象转成路由对象
const menuToRoute = (menu, parentName) => {
  if (!menu.component) {
    return null;
  } else {
    return {
      name: menu.name,
      path: menu.path,
      meta: { parentName: parentName },
      component: () => import(`@/views/${menu.component}.vue`),
    };
  }
};
